(async () => {
    const { Core } = await importModule('Core');
    const {
        fetchHTML,
        $isEmpty,
        $show,
        $clone,
        Routes
    } = await importModule('Utils');

    const ATTR_PRODUCT_ID = 'product-id';
    const ATTR_LIMIT = 'limit';
    const SEL_WRAPPER = '[data-swiper-wrapper]';
    const SEL_SLIDESHOW = 'slideshow-inline';

    const RQ_SECTION_ID = 'r_product-recommendations-slides';

    customElements.define('product-recommendations', class extends Core {
        elements = {
            template: '[data-template]'
        }

        async render() {
            if (this._renderPromise) return this._renderPromise;
            this._renderPromise = this._render();
            return this._renderPromise;
        }

        async _render() {
            this._initContainer();
            const hasRecommendations = await this._setRecommendations();
            if (!hasRecommendations) return;
            this._showRecommendations();
            await this._syncSlideshows();
            this._observeSizeChanges();
        }

        _initContainer() {
            this.$container = $clone(this.$template);
        }

        async _setRecommendations() {
            const $doc = await fetchHTML(`${Routes('productRecommendations')}?${this.fetchParams.toString()}`);
            if (!this.isConnected) return false;
            if (!$doc) {
                this.getParentSection()?.remove();
                return false;
            }
            const $section = $doc.getElementById(`shopify-section-${RQ_SECTION_ID}`);
            if (!$section || $isEmpty($section)) {
                this.getParentSection()?.remove();
                return false;
            }
            const $wrapper = this.$container.querySelector(SEL_WRAPPER);
            if (!$wrapper) {
                this.getParentSection()?.remove();
                return false;
            }
            $wrapper.replaceChildren(...$section.cloneNode(true).childNodes);
            return true;
        }

        _showRecommendations() {
            this.replaceChildren(...this.$container.childNodes);
            $show(this);
        }

        async _syncSlideshows() {
            if (!customElements.get(SEL_SLIDESHOW)) {
                await customElements.whenDefined(SEL_SLIDESHOW);
            }
            this._scheduleSlideshowUpdate();
        }

        _observeSizeChanges() {
            if (this._resizeObserver || typeof ResizeObserver === 'undefined') return;
            this._resizeObserver = new ResizeObserver(() => this._scheduleSlideshowUpdate());
            this._resizeObserver.observe(this);
            this.querySelectorAll(SEL_SLIDESHOW).forEach(slideshow => this._resizeObserver.observe(slideshow));
        }

        _scheduleSlideshowUpdate() {
            if (this._updateFrame) return;
            this._updateFrame = requestAnimationFrame(() => {
                this._updateFrame = requestAnimationFrame(() => {
                    this._updateFrame = null;
                    this._updateSlideshows();
                });
            });
        }

        _updateSlideshows() {
            this.querySelectorAll(SEL_SLIDESHOW).forEach(slideshow => {
                if (slideshow.swiper && !slideshow.swiper.destroyed) {
                    slideshow.swiper.update();
                    return;
                }
                if (typeof slideshow.render === 'function' && !slideshow.swiper) {
                    slideshow.render();
                }
            });
        }

        disconnect() {
            this._resizeObserver?.disconnect();
            this._resizeObserver = null;
            if (this._updateFrame) {
                cancelAnimationFrame(this._updateFrame);
                this._updateFrame = null;
            }
        }

        get fetchParams() {
            return new URLSearchParams({
                product_id: this.productId,
                limit: +this.limit,
                section_id: RQ_SECTION_ID
            });
        }

        get productId() {
            return this.getAttribute(ATTR_PRODUCT_ID);
        }

        get limit() {
            return this.getAttribute(ATTR_LIMIT);
        }
    })
})();
